import { Button, Col, DatePicker, Form, Input, Modal, notification, Row, Select } from 'antd';
import { InverterApi } from 'api/InverterApi';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { inverterActions } from 'features/Inverter/inverterSlice';
import { selectIsDisable } from 'features/Login/authSlice';
import { inverterInfo, objectDevice } from 'models';
import moment from 'moment';
import * as React from 'react';
import { selectPlantItemSidebar } from '../Sidebar/sidebarSlice';
import style from './Modal.module.scss';

export interface AddEditFormInverterProps {
  SensorType: objectDevice[];
  isEvent: boolean;
  itemInverter: inverterInfo | undefined;
  isModalVisible: boolean;
  setIsModalVisible: (value: boolean) => void;
  // setGatewayList: (value: inverterInfo[]) => void;
}

export default function AddEditFormInverter({
  isEvent,
  itemInverter,
  isModalVisible,
  setIsModalVisible,
  SensorType,
}: // setGatewayList,
AddEditFormInverterProps) {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const [itemInverterInfo, setItemInverterInfo] = React.useState<any>();
  const plantId = useAppSelector(selectPlantItemSidebar);
  const isDisable = useAppSelector(selectIsDisable);
  const { Option } = Select;
  React.useEffect(() => {
    if (itemInverter !== undefined) {
      setItemInverterInfo({
        code: formatCode(itemInverter.code),
        label: itemInverter.label,
        installation_date: moment(itemInverter.installation_date),
        location: itemInverter.location,
        serial_number: itemInverter.serial_number,
        model: itemInverter.model,
        id: itemInverter.id,
      });
    }
  }, [itemInverter]);

  const formatCode = (string: string) => {
    if (string.length <= 0) return 0;
    return string.substr(1, string.length - 1);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const openNotificationWithIcon = (type: string, message: string) => {
    if (type === 'success' || type === 'error') notification[type]({ message: message });
    return;
  };

  const handleOk = async (values: inverterInfo) => {
    try {
      if (!isEvent) {
        // const itemInverter: inverterInfo = {
        //   code: formatCodeItemPlant(values.code),
        //   label: values.label,
        //   installation_date:
        //     values.installation_date === undefined ? 0 : Number(values.installation_date),
        //   location: values.location,
        //   serial_number: values.serial_number === undefined ? undefined : values.serial_number,
        //   model: values.model,
        // };
        // await gatewayApi.add(itemInverter);
        // const res = await gatewayApi.fetchGateways({ _limit: 5, _page: 0 });
        openNotificationWithIcon('success', 'create device successfully');
        // setGatewayList(res.data);
      } else {
        const objectInverter = {
          id: itemInverter?.id,
          code: formatCodeItemPlant(values.code),
          label: values.label,
          installation_date:
            values.installation_date === undefined ? 0 : Number(values.installation_date),
          serial_number: values.serial_number,
        };
        await InverterApi.update(objectInverter);
        if (plantId) {
          dispatch(
            inverterActions.fetchInverterList({
              type: 'inverter-list?plant_id',
              id: plantId,
              page: 0,
              page_size: 10,
            })
          );
          dispatch(inverterActions.fetchInverterInfo(itemInverterInfo));
        }
        openNotificationWithIcon('success', 'edit device successfully');
      }
    } catch (error) {
      openNotificationWithIcon('error', 'please check the data again!');
    }
    setIsModalVisible(false);
    form.resetFields();
  };

  const formatCodeItemPlant = (code: string) => {
    const count = code.length;
    let newcode;
    if (count === 1) {
      newcode = `I000${code}`;
    } else if (count === 2) {
      newcode = `I00${code}`;
    } else if (count === 3) {
      newcode = `I0${code}`;
    } else {
      newcode = `I${code}`;
    }
    return newcode;
  };

  // const [selectGateWayList, setSelectGateWayList] = React.useState([
  //   'Gateway ECU-1051-TL',
  //   'Gateway ECU-1251-TL',
  // ]);

  return (
    <Modal
      visible={isModalVisible}
      footer={
        <div className={style.footer_modal}>
          <Button onClick={handleCancel} className={style.btn_cancel}>
            Cancel
          </Button>
          <Button disabled={isDisable} onClick={() => form.submit()} className={style.btn_submit}>
            Submit
          </Button>
        </div>
      }
      width={720}
      onCancel={handleCancel}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={itemInverterInfo}
        onFinish={(values) => handleOk(values)}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="code"
              label="Code :"
              rules={[
                {
                  pattern: /^(?:\d*)$/,
                  message: 'Value should contain just number',
                },
                { required: true, message: 'Please enter Code' },
              ]}
            >
              <Input
                disabled={isEvent}
                addonBefore="I"
                maxLength={4}
                placeholder="Please enter Code"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="label"
              label="Label :"
              rules={[{ required: true, message: 'Please enter Label' }]}
            >
              <Input placeholder="Please enter Label" />
            </Form.Item>
          </Col>
        </Row>
        {/* <Row gutter={16}>
          <Col span={24}>
            <Form.Item name="location" label="Location :">
              <Input placeholder="Please enter location" />
            </Form.Item>
          </Col>
        </Row> */}
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="model"
              label="Model :"
              rules={[{ required: true, message: 'Please enter model' }]}
            >
              <Select disabled={isEvent} placeholder="Sensor type">
                {SensorType.map((item) => (
                  <Option value={item.name}>{item.name}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="serial_number" label="Serial Number :">
              <Input placeholder="Please enter serial number" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item name="installation_date" label="Install Date :">
              <DatePicker defaultValue={moment()} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
